// src/pages/ManageBuyPackage.js
import React, { useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import {
  Breadcrumb,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Badge,
} from "@themesberg/react-bootstrap";

import PlomCover from "../assets/img/profile-cover.jpg";

// ===== Badge สถานะ (ตามแท็บ) =====
// ===== Badge สถานะ =====
const StatusBadge = ({ state }) => {
  switch (state) {
    case "NEW":
      return <Badge bg="secondary">ใช้งาน</Badge>;
    case "IN_PROGRESS":
      return (
        <Badge bg="warning" text="dark">
          ไม่ได้ใช้งาน
        </Badge>
      );
    default:
      return <Badge bg="dark">-</Badge>; 
  }
};

// ===== MOCK: บทความ =====
const INITIAL_POSTS = [
  {
    img: PlomCover,
    title: "PLOM SYSTEM ระบบจัดการข้อมูลร้านซักอบรีด",
    state: "NEW",
    views: 1526,
  },
  {
    img: PlomCover,
    title: "PLOM SYSTEM ระบบจัดการข้อมูลร้านซักอบรีด",
    state: "NEW",
    views: 1526,
  },
];

const PostsTable = ({ rows }) => {
  const RowItem = ({ idx, r }) => (
    <tr>
      <td>{idx}</td>
      {/* รูปภาพ */}
      <td
        style={{
          width: 200,
        }}
      >
        <img
          src={r.img}
          alt={r.title}
          className="img-thumbnail"
          style={{ width: 140, height: 90, objectFit: "cover" }}
        />
      </td>

      {/* ชื่อบทความ – อนุญาตให้ขึ้นบรรทัด */}
      <td
        className="text-wrap"
        style={{
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
        }}
      >
        {r.title}
      </td>

      {/* ประเภท / ยอดวิว */}
      <td className="text-center">
        <StatusBadge state={r.state} />
      </td>

      {/* รายละเอียด */}
      <td className="text-center">
        <Button size="sm" variant="info">
          รายละเอียด
        </Button>
      </td>
    </tr>
  );

  return (
    <Card border="light" className="shadow-sm mb-4">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">รหัส</th>
              <th className="border-0">รูปภาพ</th>
              <th className="border-0">ชื่อโฆษณา</th>
              <th className="border-0 text-center">สถานะ</th>
              <th className="border-0 text-center">รายละเอียด</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <RowItem key={`post-${i}`} idx={i + 1} r={r} />
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

// ===== main page =====
export default function ManageAds() {
  const [posts, setPosts] = useState(INITIAL_POSTS);

  // modal state
  const [show, setShow] = useState(false);

  // form state
  const [img, setImg] = useState(
    "https://via.placeholder.com/140x90?text=Thumb"
  );
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("ข่าวสาร");
  const [views, setViews] = useState(0);

  const handleSubmit = (e) => {
    e.preventDefault();
    setPosts((prev) => [
      ...prev,
      { img, title, category, views: Number(views || 0) },
    ]);
    setShow(false);
    setImg("https://via.placeholder.com/140x90?text=Thumb");
    setTitle("");
    setCategory("ข่าวสาร");
    setViews(0);
  };

  return (
    <>
      {/* header */}
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          />
          <h4>โฆษณา</h4>
        </div>
        <div className="btn-toolbar gap-2 mb-2 mb-md-0">
          <Button variant="success">
            <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
            เพิ่มโฆษณา
          </Button>
        </div>
      </div>

      {/* table */}
      <PostsTable rows={posts} />
    </>
  );
}
